import { ITenant } from 'app/shared/model/tenant.model';
import { LabServiceType } from 'app/shared/model/enumerations/lab-service-type.model';
import { EntityType } from 'app/shared/model/enumerations/entity-type.model';

export interface ITenantAssociation {
  id?: string;
  associatedDate?: number;
  internal?: boolean | null;
  leavingDate?: number | null;
  openingTime?: string | null;
  closeTime?: string | null;
  createdDtm?: number | null;
  createdBy?: string | null;
  modifiedBy?: string | null;
  leftAssociation?: boolean | null;
  active?: boolean;
  cursor?: number;
  lastUpdated?: number;
  microSec?: number;
  timestampEntry?: number;
  labAssociationType?: keyof typeof LabServiceType | null;
  tenantType?: keyof typeof EntityType | null;
  otherTenantType?: keyof typeof EntityType | null;
  tenant?: ITenant;
  associatedTenant?: ITenant;
}

export const defaultValue: Readonly<ITenantAssociation> = {
  internal: false,
  leftAssociation: false,
  active: false,
};
